import {PATHS, RES_STATUS, SYS_USER_TYPE} from "../utils/constants";
import {getUserInfo, submitFace, setCommonZone, modifyPwd} from '../services/account';
import {message} from 'antd';
export default {
  namespace: 'personal',
  state: {},
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getUserInfo(_, { put, call, select }) {
      const { locale } = yield select(state => state.i18n);
      const { status, data, msg } = yield call(getUserInfo, { locale });
      if (status === 0) {
        yield put({ type: 'login/update', payload: { userInfo: data } });
        sessionStorage.setItem('userInfo', JSON.stringify(data));
      } else {
        message.error(msg);
      }
    },
    *submitFace({ faceUrl }, { put, call, select }) {
      const { userInfo } = yield select(state => state.login);
      const { userId } = userInfo;
      const { locale } = yield select(state => state.i18n);
      const { msg, status } = yield call(submitFace, {
        userId,
        userType: SYS_USER_TYPE.internal,
        imgPath: faceUrl,
        lang: locale
      });
      if (status === RES_STATUS.success) {
        message.success(msg);
        yield put({ type: 'getUserInfo' });
      } else {
        message.error(msg);
      }
    },
    *saveCommonZone({ commonZoneIds }, { put, select, call }) {
      const { locale } = yield select(state => state.i18n);
      const { msg, status } = yield call(setCommonZone, {
        commonZoneIds,
        lang: locale
      });
      if (status === RES_STATUS.success) {
        message.success(msg);
        yield put({ type: 'getUserInfo' });
      } else {
        message.error(msg);
      }
    },
    *modifyPwd({pwdInfo}, {put, select, call}){
      const {locale} = yield select(state => state.i18n);
      const {msg, status} = yield call(modifyPwd, {
        pwdInfo, lang: locale
      });
      if(status === RES_STATUS.success){
        message.success(msg);
      } else {
        message.error(msg);
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/personal.js